/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, memo, useCallback, useState } from "react";
import InfoMerchandising from "./InfoMerchandising";
import useStyles from "./styles";
import RewardMerchandising from "./RewardMerchandising";
import ProductItem from "components/ProductItem";
import ConfirmOrder from "components/ConfirmOrder";
import NoneData from "components/NoneData";

import { getMerchandisingDetailAction } from "store/actions/SpecialOfferPageAction";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { setCartAction } from "store/actions/OrderPageAction";
import { useHistory } from "react-router-dom";
import { isEmpty } from "lodash";

let changeListProduct = [];

const MerchandisingDetailPage = memo(props => {
	const classes = useStyles();
	const history = useHistory();
	const {
		getMerchandisingDetail,
		carts,
		setCart,
		merchandisingDetail,
		infoShop
	} = props;

	const [listProductApplys, setListProductApplys] = useState([]);
	const [listProductDisplays, setListProductDisplays] = useState([]);
	const business = infoShop?.business || "THOPHAT";

	const idNotification = new URLSearchParams(history.location.search).get(
		"id"
	);
	const height = `calc(100vh - ${carts?.length > 0 ? 140 : 60}px)`;

	useEffect(() => {
		if (!carts) {
			return;
		}
		changeListProduct = carts;
	}, [carts]);

	useEffect(() => {
		if (!idNotification) {
			history.push("/home");
			return;
		}
		const merchandising = {
			business: business,
			merchandisingId: idNotification
		};
		getMerchandisingDetail(merchandising);
	}, [idNotification]);

	const configDataProduct = data => {
		return data.map(item => {
			let index = carts.findIndex(order => order.id === item.id);
			if (index > -1) {
				return { ...item, isSelected: true };
			} else {
				return { ...item, isSelected: false };
			}
		});
	};

	useEffect(() => {
		if (!merchandisingDetail?.productApplys) {
			return;
		}
		const dataListBestSale = configDataProduct(
			merchandisingDetail?.productApplys
		);
		setListProductApplys(dataListBestSale);
	}, [merchandisingDetail?.productApplys]);

	useEffect(() => {
		if (!merchandisingDetail?.productDisplays) {
			return;
		}
		const dataListBestSale = configDataProduct(
			merchandisingDetail?.productDisplays
		);
		setListProductDisplays(dataListBestSale);
	}, [merchandisingDetail?.productDisplays]);

	const updateChangeListProduct = useCallback(item => {
		if (changeListProduct?.find(product => product.id === item.id)) {
			const dataFilter = changeListProduct.filter(
				el => el.id !== item.id
			);
			changeListProduct = dataFilter;
		} else {
			changeListProduct = [...changeListProduct, item];
		}
		setCart(changeListProduct);
	}, []);

	const handleConfirmOrder = () => {
		history.push("/carts");
	};

	const getChangeListProduct = () => {
		return changeListProduct;
	};

	return !isEmpty(merchandisingDetail) ? (
		<Grid
			style={{
				height: height,
				overflow: "hidden"
			}}
		>
			<Grid
				classes={{ root: classes.root }}
				style={{
					height: height
				}}
			>
				<InfoMerchandising merchandisingDetail={merchandisingDetail} />
				{merchandisingDetail?.rewardLevels?.map(rewardLevel => (
					<RewardMerchandising
						rewardLevel={rewardLevel}
						key={rewardLevel?.id}
					/>
				))}
				{listProductApplys?.length > 0 && (
					<React.Fragment>
						<Grid
							classes={{ root: classes.title }}
							style={{ marginTop: 10 }}
						>
							Sản phẩm áp dụng
						</Grid>
						{listProductApplys?.map(product => (
							<ProductItem
								product={product}
								key={product?.id}
								updateChangeListProduct={
									updateChangeListProduct
								}
								products={listProductApplys}
								carts={carts}
							/>
						))}
					</React.Fragment>
				)}
				{listProductDisplays?.length > 0 && (
					<React.Fragment>
						<Grid
							classes={{ root: classes.title }}
							style={{ marginTop: 10 }}
						>
							Sản phẩm trưng bày
						</Grid>
						{listProductDisplays?.map(product => (
							<ProductItem
								product={product}
								key={product?.id}
								updateChangeListProduct={
									updateChangeListProduct
								}
								products={listProductDisplays}
								carts={carts}
							/>
						))}
					</React.Fragment>
				)}
			</Grid>
			{carts?.length > 0 && (
				<ConfirmOrder
					bottom={0}
					handleConfirmOrder={handleConfirmOrder}
					listProduct={carts}
					getChangeListProduct={getChangeListProduct}
				/>
			)}
		</Grid>
	) : (
		<Grid classes={{ root: classes.centerPage }}>
			<NoneData />
		</Grid>
	);
});

const mapStateToProps = state => {
	return {
		carts: state.orderPageReducer.carts,
		merchandisingDetail: state.specialOfferPageReducer.merchandisingDetail,
		infoShop: state.homePageReducer.infoShop
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getMerchandisingDetail: params => {
			dispatch(getMerchandisingDetailAction(params));
		},
		setCart: params => {
			dispatch(setCartAction(params));
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(MerchandisingDetailPage);
